import {
  CaseFilterState,
  DateRangeFiltersState,
  QueryFiltersState,
  SlideFiltersState,
  SpecimenFiltersState,
} from "./CaseAdminFilters.contracts";
import { parseBoolean } from "./CaseAdminFilters.utils";

export const caseFiltersStateEmpty: CaseFilterState = {
  accession: "",
  accessioningLab: "",
  activeAssignmentName: "",
  billerName: "",
  billingType: "",
  clinicNumber: "",
  grossedByCert: "",
  orderingDoctorName: "",
  patientAddressState: "",
  patientClinicClinicGroupName: "",
  patientClinicLocationState: "",
  patientClinicName: "",
  patientClinicSonicPracticeName: undefined, // deprecated for sonicPracticeName
  sonicPracticeName: "",
  patientDateOfBirth: "",
  patientInsuranceInsuranceCompanyName: "",
  patientName: "",
  pcClia: "",
  priority: "",
  qaReviewHold: [],
  source: "",
  specimenBagBarcode: "",
  status: "",
  type: "",
};

export const dateRangeFiltersStateEmpty: DateRangeFiltersState = {
  receivedDateAfter: "",
  receivedDateBefore: "",
  collectedDateAfter: "",
  collectedDateBefore: "",
  accessionCompletedAfter: "",
  accessionCompletedBefore: "",
  finalizedAtAfter: "",
  finalizedAtBefore: "",
};

export const slideFiltersStateEmpty: SlideFiltersState = {
  slidesStatus: "",
  slidesStainName: "",
  slidesLab: "",
  slidesSlideReviewReason: "",
  slidesQcStatus: "",
  slidesScannedDateAfter: "",
  slidesScannedDateBefore: "",
  slidesExpectedUploadByAfter: "",
  slidesExpectedUploadByBefore: "",
};

export const specimenFiltersStateEmpty: SpecimenFiltersState = {
  specimensBiopsyType: "",
  specimensProcedure: "",
  specimensType: "",
  specimensSource: "",
  specimensSite: "",
  grossCompletedAfter: "",
  grossCompletedBefore: "",
};

export const queryFiltersStateEmpty: QueryFiltersState = {
  isDiagnostic: false,
  reviewed: false,
  dataEntry: undefined,
  billingEntry: undefined,
  hasFinalizingSignature: false,
  unviewed: false,
  selfPay: false,
  isManuallyAccessioned: undefined,
};

export const createQueryFiltersStateInit = (
  usp: URLSearchParams
): QueryFiltersState => ({
  ...queryFiltersStateEmpty,
  isDiagnostic: !!usp.get("isDiagnostic"),
  reviewed: !!usp.get("reviewed"),
  dataEntry: parseBoolean(usp.get("dataEntry")),
  billingEntry: parseBoolean(usp.get("billingEntry")),
  hasFinalizingSignature: !!usp.get("hasFinalizingSignature"),
  unviewed: !!usp.get("unviewed"),
  selfPay: !!usp.get("selfPay"),
  isManuallyAccessioned: usp.get("isManuallyAccessioned")
    ? usp.get("isManuallyAccessioned") === "true"
    : undefined,
});
